const Endpoints = {
    Auth: {
        LOGIN: "/api/v1/auth/login"
    },
    User: {
        GET_USER_LIST: "/api/v1/user",
        GET_USER: "/api/v1/user/",
        UPDATE_USER: "/api/v1/user/edit/"
    },
    Tournament: {
        GET_TOURNAMENT_LIST: "/api/v1/tournament",
        GET_ORGANIZER_TOURNAMENTS: "/api/v1/tournament?organizerOnly=true",
        GET_TOURNAMENT: "/api/v1/tournament/",
        CREATE_TOURNAMENT: "/api/v1/tournament/create",
        UPDATE_TOURNANET: "/api/v1/tournament/update/",
        DELETE_TOURNAMENT: "/api/v1/tournament/delete/"
        ,RESULTS: "/api/v1/tournament/"
    },
    Wallet: {
        BALANCE: "/api/v1/wallet/balance",
        ADMIN_USER: "/api/v1/wallet/admin-user/"
    },
    Category: {
        GET_CATEGORY_LIST: "/api/v1/category",
        GET_CATEGORY: "/api/v1/category/",
        CREATE_CATEGORY: "/api/v1/category/create",
        UPDATE_CATEGORY: "/api/v1/category/update/",
        DELETE_CATEGORY: "/api/v1/category/delete/"
    },
    Games: {
        GET_GAMES_LIST: "/api/v1/game",
        GET_GAMES: "/api/v1/game/",
        CREATE_GAMES: "/api/v1/game/create",
        UPDATE_GAMES: "/api/v1/game/update/",
        DELETE_GAMES: "/api/v1/game/delete/"
    },
    Player: {
        GET_PLAYER_LIST: "/api/v1/player",
        GET_PLAYER: "/api/v1/player/",
        CREATE_PLAYER: "/api/v1/player/create",
        UPDATE_PLAYER: "/api/v1/player/update/",
        DELETE_PLAYER: "/api/v1/player/"
    },
    Team: {
        GET_TEAM_LIST: "/api/v1/team",
        GET_TEAM: "/api/v1/team/",
        CREATE_TEAM: "/api/v1/team/create",
        UPDATE_TEAM: "/api/v1/team/update/",
        DELETE_TEAM: "/api/v1/team/"
    },
    Post: {
        GET_POST_LIST: "/api/v1/post",
        GET_POST: "/api/v1/post/",
        CREATE_POST: "/api/v1/post/create",
        UPDATE_POST: "/api/v1/post/update/"
    },
    Comment: {
        GET_COMMENT_LIST: "/api/v1/comment",
        GET_COMMENT: "/api/v1/comment/",
        UPDATE_COMMENT: "/api/v1/comment/update/"
    },
    Banner: {
        GET_BANNER_LIST: "/api/v1/banner",
        GET_BANNER: "/api/v1/banner/",
        CREATE_BANNER: "/api/v1/banner/create",
        UPDATE_BANNER: "/api/v1/banner/update/"
    },
    ImageLibrary: {
        CATEGORIES: "/api/v1/image-library/categories",
        ASSETS: "/api/v1/image-library/assets",
        ADMIN_CATEGORIES_WITH_ASSETS: "/api/v1/image-library/admin/categories-with-assets"
    },
    Quiz: {
        // Admin endpoints
        LIST_ADMIN: "/api/v1/quiz/admin",
        GET_ADMIN: "/api/v1/quiz/admin/", // + :id
        CREATE: "/api/v1/quiz",
        UPDATE: "/api/v1/quiz/", // + :id
        DELETE: "/api/v1/quiz/", // + :id
        // Public/mobile endpoints
        PUBLIC_LIST: "/api/v1/quiz",
        PUBLIC_GET: "/api/v1/quiz/", // + :id
        SUBMIT: "/api/v1/quiz/", // + :id + /submit
        STATS: "/api/v1/quiz/" // + :id + /stats
    },
    Products: {
        LIST: "/api/v1/products",
        SINGLE: "/api/v1/products/", // + :id
        CREATE: "/api/v1/products",
        UPDATE: "/api/v1/products/", // + :id
        DELETE: "/api/v1/products/",  // + :id
        UPLOAD_IMAGES: "/api/v1/products/upload-images"
    },
    ProductCategories: {
        LIST: "/api/v1/products/categories",
        SINGLE: "/api/v1/products/categories/", // + :id
        CREATE: "/api/v1/products/categories",
        UPDATE: "/api/v1/products/categories/", // + :id
        DELETE: "/api/v1/products/categories/"  // + :id
    },
    Orders: {
        LIST: "/api/v1/orders",
        SINGLE: "/api/v1/orders/", // + :id
        UPDATE_STATUS: "/api/v1/orders/" // + :id + "/status"
    },
    Version: {
        GET_VERSION: "/api/v1/version",
        UPDATE_VERSION: "/api/v1/version"
    },
    Country: {
        LIST: "/api/v1/country",
        CREATE: "/api/v1/country",
        UPDATE: "/api/v1/country/",
        DELETE: "/api/v1/country/"
    },
    UserBadge: {
        LIST: "/api/v1/user-badge",
        CREATE: "/api/v1/user-badge",
        UPDATE: "/api/v1/user-badge/",
        DELETE: "/api/v1/user-badge/"
    },
    Lobby: {
        GET: "/api/v1/lobby",
        UPDATE: "/api/v1/lobby"
    },
    Rewards: {
        CONFIG: "/api/v1/rewards/config"
    }
}
export default Object.freeze(Endpoints)
